package one.healthium.payments.models

data class ProductOptions(
    val id: String,
    val type: ProductType,
)

enum class ProductType {
    Subs,
    InApp,
}
